import { BrowserError, isBrowser } from '@rogers/cdk/common/utils';

function Default(defaultValue) {
    return function Constructor(target, prop) {
        const NG_ON_ONIT_NAME = 'ngOnInit';
        const ngOnInitClone = target[NG_ON_ONIT_NAME];
        Object.defineProperty(target, NG_ON_ONIT_NAME, {
            value: function () {
                if (this[prop] === null ||
                    this[prop] === undefined ||
                    this[prop] === '') {
                    this[prop] = defaultValue;
                }
                if (ngOnInitClone) {
                    ngOnInitClone.call(this);
                }
            },
        });
    };
}

function Required() {
    return function Constructor(target, prop) {
        const NG_ON_ONIT_NAME = 'ngOnInit';
        const ngOnInitClone = target[NG_ON_ONIT_NAME];
        Object.defineProperty(target, NG_ON_ONIT_NAME, {
            value: function () {
                if (this[prop] === null || this[prop] === undefined) {
                    BrowserError.throw(target.constructor.name +
                        `: ${prop} is required, but was not provided`);
                    return;
                }
                if (ngOnInitClone) {
                    ngOnInitClone.call(this);
                }
            },
        });
    };
}

/**
 *
 * @description Wraps methods with SSR check
 */
function ssr() {
    return (target, key, descriptor) => {
        const initialMethod = descriptor.value;
        descriptor.value = function () {
            if (isBrowser() && initialMethod) {
                initialMethod.apply(this, arguments);
            }
        };
    };
}

/**
 * Generated bundle index. Do not edit.
 */

export { Default, Required, ssr };
